import { createFileRoute } from '@tanstack/react-router';
import { SchedulesPage } from '@/pages/schedules/SchedulesPage';

export const Route = createFileRoute('/schedules')({
  component: SchedulesPage,
});
